import { render } from "./PropertyMain.vue?vue&type=template&id=2dbff0f6&scoped=true"
import script from "./PropertyMain.vue?vue&type=script&lang=js"
export * from "./PropertyMain.vue?vue&type=script&lang=js"

import "./PropertyMain.vue?vue&type=style&index=0&id=2dbff0f6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dbff0f6"]])

export default __exports__